module.exports = __webpack_public_path__ + "static/flatart-insta-ss-c289f6fd07499238c2cd315cb52cc7e4.png";